import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";
import { GameState } from "../objects/GameState";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.FitFive;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "FitFive.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "FitFive.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "FitFive.Phaser.HowToPlay.tabletInstructions";
    }

    create() {
        super.create();

        // This properly loads gamestate for the next scene
        GameState.current = new GameState(null);
    }
}



// WEBPACK FOOTER //
// ./src/games/FitFiveGame/scenes/IntroductionScene.ts